export class Endpoints {
  private static readonly users = "/users";
  private static readonly products = "/products";
  private static readonly addresses = "/addresses";
  private static readonly orders = "/orders";
  private static readonly sizes = "/sizes";
  private static readonly generalCategories = "/generalcategories";

  /**
   * method: GET
   */
  public static readonly home = "/home";

  // users
  /**
   * method: POST
   */
  static readonly login = `${Endpoints.users}/login`;
  /**
   * method: POST
   */
  static readonly register = `${Endpoints.users}/register`;
  /**
   * method: POST
   */
  static readonly numberRegister = `${Endpoints.users}/numberregister`;
  /**
   * method: POST
   */
  static readonly loginWithPassword = `${Endpoints.users}/loginwithpassword`;
  /**
   * method: POST
   */
  static readonly loginWithCode = `${Endpoints.users}/loginwithcode`;
  /**
   * method: POST
   */
  static readonly confirmVerificationCode = `${Endpoints.users}/confirm`;
  /**
   * method: POST
   */
  static readonly forgotPassword = `${Endpoints.users}/forgot`;
  /**
   * method: POST
   */
  static readonly changePassword = `${Endpoints.users}/change`;
  /**
   * method: POST
   */
  static readonly editUser = `${Endpoints.users}/edit`;
  /**
   * method: GET
   */
  static readonly infoUser = `${Endpoints.users}/info`;

  // products
  /**
   * method: GET
   */
  static readonly generalCategoryProducts = `${Endpoints.products}/general`;
  /**
   * method: GET
   */
  static readonly subCategoryProducts = `${Endpoints.products}/sub`;
  /**
   * method: GET
   */
  static readonly categoryProducts = `${Endpoints.products}/category`;
  /**
   * method: GET
   */
  static readonly productInfo = `${Endpoints.products}/info`;
  /**
   * method: GET
   */
  static readonly cartProducts = `${Endpoints.products}/cart`;
  /**
   * method: POST
   */
  static readonly verifyCartItems = `${Endpoints.products}/verify_cart`;

  // addresses
  /**
   * method: POST
   */
  static readonly addAddress = `${Endpoints.addresses}/add`;
  /**
   * method: GET
   */
  static readonly listAddress = `${Endpoints.addresses}/list`;
  /**
   * method: POST
   */
  static readonly editAddress = `${Endpoints.addresses}/edit`;
  /**
   * method: POST
   */
  static readonly removeAddress = `${Endpoints.addresses}/remove`;

  // orders
  /**
   * method: POST
   */
  static readonly requestPayment = `${Endpoints.orders}/request`;
  /**
   * method: POST
   */
  static readonly verifyPayment = `${Endpoints.orders}/verify`;
  /**
   * method: POST
   */
  static readonly deleteOrder = `${Endpoints.orders}/delete-order`;
  /**
   * method: POST
   */
  static readonly checkDiscountCode = `${Endpoints.orders}/check-discount-code`;

  // sizes
  /**
   * method: GET
   */
  static readonly sizesList = `${Endpoints.sizes}/list`;

  // colors
  /**
   * method: GET
   */
  static readonly color = "/color/";

  // generalcategories
  /**
   * method: GET
   */
  static readonly generalCategoriesList = `${Endpoints.generalCategories}/list`;

  // config
  /**
   * method: GET
   */
  static readonly deliveryInfo = "configs/delivery_info";
}
